<template>
  <div>
    <notifications></notifications>
    <router-view :to="path"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: "/dashboard",
    };
  },
  watch: {
  '$sidebar.showSidebar'(val) {
    if (val) {
      document.body.classList.add('nav-open');
      if (!document.getElementById('bodyClick')) {
        const node = document.createElement('div');
        node.id = 'bodyClick';
        node.style.position = 'fixed';
        node.style.top = 0;
        node.style.right = '230px';
        node.style.width = 'calc(100vw - 230px)';
        node.style.height = '100vh';
        node.style.zIndex = 9998;
        node.onclick = () => {
          this.$sidebar.displaySidebar(false);
        };
        document.body.appendChild(node);
      }
    } else {
      document.body.classList.remove('nav-open');
      const node = document.getElementById('bodyClick');
      if (node) document.body.removeChild(node);
    }
  }
}
};
</script>


<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
  .sidebar-overlay {
  position: fixed;
  top: 0; left: 0; width: 100vw; height: 100vh;
  z-index: 9998;
  background: rgba(0,0,0,0.3);
}
}
</style>
